export const assignLinkedUserGroup = (participant, userGroupId) => {
  if (participant?.linkedUser) {
    participant.linkedUser.userGroupId = userGroupId
  }

  return participant
}

export const buildLinkedUserUpdatePayload = (user = {}, participant = {}, linkedUserGroupId = null) => {
  const linkedUserPayload = {
    ...user,
    userGroupId: linkedUserGroupId,
    name: participant.name,
    surname: participant.surname,
    login: participant.login,
    orgId: participant.orgId,
    personalId: participant.personalNumber,
  }

  delete linkedUserPayload.password

  if (participant.password && participant.password.length) {
    linkedUserPayload.password = participant.password
  }

  return linkedUserPayload
}
